var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "selectBoxWithLabel", class: { isPc: !_vm.isSp } },
      [
        _c(
          "InputLabel",
          {
            staticClass: "labelArea",
            class: {
              isPc: !_vm.isSp,
              isHasLabel: !_vm.isSp && (_vm.required || _vm.optional),
              isPcModal: _vm.isPcModal,
            },
            attrs: {
              required: _vm.required,
              optional: _vm.optional,
              "is-pc-modal": _vm.isPcModal,
              "is-sotsunen": _vm.isSotsunen,
            },
          },
          [_vm._v("\n      " + _vm._s(_vm.areaLabel) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "inputsArea",
            class: {
              isPc: !_vm.isSp,
              todofuken: _vm.areaLabel === "都道府県",
              gakunen: _vm.areaLabel.includes("学年") && !_vm.isProfileEditPage,
              isProfileEditPage: _vm.isProfileEditPage,
            },
          },
          [
            _c("SelectBox", {
              attrs: {
                "placeholder-value": _vm.placeholder,
                "has-error": _vm.hasError,
                "select-list": _vm.selectList,
                disabled: _vm.disabled,
                "is-pc-modal": _vm.isPcModal,
                optional: _vm.optional,
              },
              on: { change: _vm.onChange },
              model: {
                value: _vm.selected,
                callback: function ($$v) {
                  _vm.selected = $$v
                },
                expression: "selected",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "underInputArea",
        class: { isPc: !_vm.isSp, isPcModal: _vm.isPcModal },
      },
      [
        _c("PartialErrorMessage", {
          staticClass: "partialErrorComponent",
          attrs: { "is-sp-flg": true, error: _vm.errorFromOuter },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }